import {
  buildAdminListQuery,
  type TAdminListParams,
} from '@/core/lib/table-query'

export const teamLogoEndpoints = {
  list: (params: TAdminListParams) =>
    `/admin/team-logos?${buildAdminListQuery(params)}`, // GET
  create: '/admin/team-logos', // POST {url} (metadata; rarely used)
  presign: '/admin/team-logos/presign', // POST {content_type} → {upload_url, key}
  finalize: '/admin/team-logos/finalize', // POST {key} → new system logo
  replace: (id: string) => `/admin/team-logos/${id}`, // PATCH {key} → version bumps
  setActive: (id: string) => `/admin/team-logos/${id}/active`, // PATCH {is_active}
  delete: (id: string) => `/admin/team-logos/${id}`, // DELETE
}

export const teamLogoSuccessMessages = {
  teamLogoCreate: 'Takım logosu başarıyla oluşturuldu!',
  teamLogoReplace: 'Takım logosu güncellendi (versiyon artırıldı)!',
  teamLogoDelete: 'Takım logosu başarıyla silindi!',
  teamLogoActive: 'Takım logosu durumu güncellendi!',
}
